export const configCheBlue = {
    theme: "che",
    assetsPath: "/assets/che",
    layoutVersion: "V1",
    dashboard: {
        addons: {
            additionalCover: [
                {
                    isCovered: true,
                    text: "Family cover",
                },
            ],
            covered: [
                {
                    isCovered: true,
                    text: "Zero excess",
                },
                {
                    isCovered: true,
                    text: "Cover up to £7,500",
                },
                {
                    isCovered: true,
                    text: "Fire, theft & vandalism",
                },
                {
                    isCovered: true,
                    text: "Tyres & windscreen",
                },
                {
                    isCovered: true,
                    text: "Keys & undercarriage",
                },
                {
                    isCovered: true,
                    text: "Personal possessions cover",
                },
                {
                    isCovered: true,
                    text: "Max continuous rental 62 days",
                },
            ],
            notCovered: [
                {
                    isCovered: false,
                    text: "Vehicles valued over £70,000",
                },
                {
                    isCovered: false,
                    text: "Motorhomes, caravans & camper vans",
                },
                {
                    isCovered: false,
                    text: "Vehicles with over 7 seats",
                },
                {
                    isCovered: false,
                    text: "Vehicles over 3.5 tonnes",
                },
                {
                    isCovered: false,
                    text: "Off road vehicles",
                },
                {
                    isCovered: false,
                    text: "Green motion car rental",
                },
            ],
        },
    },
    icons: {
        signOut: "signout_blue.svg",
        helpCircle: "help-circle.svg",
        userIcon: "user-icon.svg",
        userPlus: "userPlus_blue.svg",
        userThemeColor: "userThemeColor_blue.svg",
        users: "users_blue.svg",
        clock: "clock_blue.svg",
        check: "check_blue.svg",
        paymentMethod: "payment-methods.png",
        menueBar: "menu-bars.svg",
        cross: "cross_blue.svg",
        chevronDown: "chevronDown_blue.svg",
        chevronDownGray: "chevronDownGray.svg",
        plusCircle: "plusCircle_blue.svg",
        plusCircleWhite: "plusCircleWhite.svg",
        refresh: "refresh_blue.svg",
        ar_refresh: "refresh_blue-white.svg",
        file: "file_blue.svg",
        arrowLeft: "arrow-left_blue.svg",
        clockWhite: "clock-white.svg",
        fileText: "file-text_blue.svg",
        editIcon: "edit_blue.svg",
        download: "download_blue.svg",
        alert: "alert.svg",
        email: "email_blue.svg",
        calender: "calender.svg",
        calenderTheme: "calender-theme_blue.svg",
        checkWhite: "checkWhite.svg",
        home: "home_blue.svg",
        homeTheme: "home-theme_blue.svg",
        trash: "trash_blue.svg",
        checkboxChecked: "checkbox_checked_blue.svg",
        checkbox: "checkbox.svg",
        visa: "payment-visa.svg",
        mastercard: "mastercard.svg",
        favIcon:"favicon_blue.svg",
        octagenCircle: "octagenCircle.svg",
        checkCircle: "check-circle.svg",
        whiteCross: "white-cross.svg",
        alertTheme: "alert-theme.svg",
        themeInfo: "theme-info_blue.svg",
        crossHeader:"cross-header.svg",
        externalLink:"externalLink.svg",
        checkedCircle:"circleChecked_blue.svg"
    },
    renewal_back_date_days: 30,
};
